import { apiClient } from '../apiClient';

export const PATHS = {
  // Mints a single-use django-sesame login token for the current user.
  // Mirrors Sparta's `/api/v1/sesame-token` (sparta/src/user/utils/authorizationHandoff.ts).
  SESAME_TOKEN: '/api/v1/sesame-token',
} as const;

type SesameTokenResponse = {
  token: string;
};

/**
 * Mint a single-use django-sesame login token for the current user.
 *
 * The request is authenticated only by the app's Bearer access token (the
 * apiClient request interceptor attaches it): Apigee verifies the JWT and
 * injects the Django session it needs, so no `sessionid` cookie is involved.
 * That is what lets the native auth handoff happen entirely in-app
 * (`handoffSesameToNative`) instead of bouncing to Sparta's www.vida.com exit
 * broker — the cross-origin cookie the bounce relied on is never persisted by
 * Android's WebView, whereas the Bearer works identically everywhere.
 *
 * Returns the token, or null on any failure (the caller falls back to closing
 * the WebView without refreshing native's session).
 */
export async function fetchSesameToken(): Promise<string | null> {
  try {
    const res = await apiClient.get<SesameTokenResponse>(PATHS.SESAME_TOKEN);
    return res.data?.token ?? null;
  } catch {
    return null;
  }
}
